import React from 'react';

const MarketPanelSectorBreadth = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Sector Market Breadth</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="sectors_market_breadth">
            <thead>
              <tr>
                <th>Total Advancing Sectors</th>
                <th>Decline Outlook</th>
                <th>Total Declining Stocks</th>
                <th>Advance Outlook</th>
                <th>Advance Decline Ratio</th>
                <th>Advance Decline Outlook</th>
              </tr>
            </thead>
            <tbody>
              {data ? (
                <tr>
                  <td>{data.total_advancing_sectors || '-'}</td>
                  <td>{data.decline_outlook || '-'}</td>
                  <td>{data.total_declining_stocks || '-'}</td>
                  <td>{data.advance_outlook || '-'}</td>
                  <td>{data.advance_decline_ratio || '-'}</td>
                  <td>{data.advance_decline_outlook || '-'}</td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSectorBreadth; 